/**
 * Script para remover reviews duplicadas (BK Reviews / Shopify Product Reviews) 
 * mantendo apenas as reviews da App externa (AReviews).
 */
(function() {
  function removeDuplicateReviews() {
    // Seletores para o sistema BK Reviews (as estrelas cinzas que aparecem no site)
    const bkSelectors = [
      '#auto-bk-star-section', 
      '#bk-product-star', 
      '#auto-bk-review-section',
      '.bk-reviews',
      '.shopify-product-reviews-badge',
      '.spr-badge',
      '.product-meta__reviews-badge'
    ];
    
    bkSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (el) {
          // Ocultamos e removemos
          el.style.setProperty('display', 'none', 'important');
          
          // Se for um link ou container específico do tema, removemos o pai para limpar o layout
          const parentBadge = el.closest('.product-meta__reviews-badge, .product-item__reviews-badge');
          if (parentBadge) {
            parentBadge.style.setProperty('display', 'none', 'important');
          }
        }
      });
    });

    // Removemos a seção completa de reviews da Shopify/BK no final da página
    const shopifyReviewSection = document.getElementById('shopify-product-reviews');
    if (shopifyReviewSection) {
      shopifyReviewSection.style.setProperty('display', 'none', 'important');
    }
  }

  // Executa imediatamente e em vários estágios do carregamento
  removeDuplicateReviews();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeDuplicateReviews);
  }
  
  window.addEventListener('load', removeDuplicateReviews);

  // MutationObserver para lidar com carregamento dinâmico (comum em apps de review)
  const observer = new MutationObserver((mutations) => {
    removeDuplicateReviews();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Manter o observer ativo por mais tempo para garantir a remoção em conexões lentas
  setTimeout(() => {
    removeDuplicateReviews();
  }, 2000);
  
  setTimeout(() => {
    removeDuplicateReviews();
  }, 5000);
})();
